import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "../../state/global/store";
import ChatDrawer from "../Chatbot/components/organisms/ChatDrawer/ChatDrawerSocket/ChatDrawerSocket";
import { setDrawerState, setQueryMetaData, setAgentData, setInitialProjectId } from "../../state/reducers/chatDrawerReducers";
//import { chatbotIconAI, chatbotIconAvatar, robGif } from "../../assets/images";
//import ChatbotLandingPage from "../Chatbot/components/molecules/ChatbotLandingPage/ChatbotLandingPage";
import { useAuth } from "../../features/auth/AuthContext";
import { srds_ai, studentDashboard_AI_chatbot_image, thumbUp, blue_dislike } from "../../assets/images/images";
import useChatSessionStore from "../Chatbot/store/chatSessionStore";
import useBranding from "../../hooks/useBranding";


const ChatDrawerWrapper = () => { 
  const isOpen = useSelector(
    (state: RootState) => state?.ChatDrawerState?.isOpen
  );
  const isWebAllowed = useSelector(
    (state: RootState) => state?.ChatDrawerState?.isWebAllowed ?? false
  );
  const queryMetaData = useSelector(
    (state: RootState) => state?.ChatDrawerState?.queryMetaData ?? null
  );
  const agentData = useSelector(
    (state: RootState) => state?.ChatDrawerState?.agentData
  );
  const initialProjectId = useSelector(
    (state: RootState) => state?.ChatDrawerState?.initialProjectId
  );



  const dispatch = useDispatch();
  const { token } = useAuth();
  const brandingConfig = useBranding();
  // global state name and token
  // const name = useSelector((state: RootState) => "");
  const globalState = useSelector((state: any) => state.globalState);
  const name = globalState?.role === "Teacher"
    ? globalState?.teacher_details?.data?.name ?? ""
    : globalState?.student_details?.data?.name ?? "";


  // const token = useSelector((state: RootState) => "");

  // Centralized configuration for the chatbot package
  const chatbotConfig = {
    // API Configuration
    baseUrl: process.env.REACT_APP_BACKEND_APP_URL || '',
    websocketUrl: `${process.env.REACT_APP_WEBSOCKET_APP_URL}${globalState?.role === "Teacher" ? '/ws/ai_assistant_teacher_bot/' : '/ws/course_chat/'}`,

    //  websocketUrl: 'wss://dev.proschool.ai/ws/ws/ai_assistant_teacher_bot/',


    // API Endpoints
    endpoints: {
      // Chatbot endpoints
      message: '',
      cachedImages: '',
      fetchHistory: '',
      fetchSessions: 'ai/api/chatbot/entity-sessions-history/',
      chatHistorySession: 'ai/api/chatbot/session/',
      chatHistoryNavigation: 'ai/api/chatbot/session-navigation/',
      handleVote: 'ai/api/chat-like-dislike/',
      uploadFile: 'ai/api/chatbot/multiple-file-upload/',
      deleteFile: 'ai/api/chatbot/files/delete/',

      // Project endpoints
      getProjects: 'ai/api/chatbot/entities/',
      getProject: 'ai/api/chatbot/entities/',
      deleteProject: '',
      updateProject: '',
      generateDescription: '',
      createProject: '',
      locations: '',
      clientNames: '',
      projectNames: 'ai/api/chatbot/entities/',
      getZolaDetails: '',

      // Revit endpoints
      getRevitSheets: '',
      getRevitViews: '',
      getRevitSections: '',

      // Image endpoints
      getFourImagesByProject: '',

      // PDF endpoints
      complianceReport: '',

      // Auth endpoints
      loginWithOtp: '',
      sendOtp: '',
      logout: '',
      authStatus: 'api//v1/auth',
    },

    // Settings
    timeout: 30000,
    defaultLimit: 10,
  };

  const user = {
    _id: token ?? "",
    user_name: name ?? "",
    user_last_name: "",
    user_profile_image: globalState
      ? globalState?.role === "Teacher"
        ? globalState?.teacher_details?.data?.ai_avatar ?? ""
        : globalState?.student_details?.data?.student_profile_pic ?? ""
      : "",
  };

  const userAvatarPath = "https://randomuser.me/api/portraits/men/32.jpg";
  const aiAvatarPath =
    "https://cdn-icons-png.flaticon.com/512/4712/4712035.png";

  // const suggestionPrompt = [
  //   "Show me which students are falling behind.",
  //   "How many students have completed the course?",
  //   "Give me Analytics of my students",
  //   "Show assignment types where students struggled.",
  // ];



  const suggestionPrompt = globalState?.role === "Teacher" ?
    ["Which students need extra help?",
      "How many students have submitted all assignments?",
      "Give me a breakdown of student performance.",
      "Show me where students are excelling.",

      "How many students passed the course?",
      "Which topics are students finding difficult?",
      "Give me a list of students who haven't completed the final exam.",
      "Show assignment types where students performed well.",

      "How many students have received feedback on their work?",
      "Which students have outstanding grades?",
      "Give me the overall class completion rate.",
      "Show me the areas where students made the most progress."] :
    ["What’s my current grade in this course?",
      "How many assignments do I have left to complete?",
      "What topics should I review to improve my grade?",
      "What resources are available for extra help?",

      "What’s the best way to study for the upcoming quiz?",
      "Have I missed any important announcements?",
      "Can I get personalized study tips based on my performance?",
      "How do I contact my instructor if I have questions?",

      "Show me the feedback on my last assignment.",
      "Which assignments are due this week?",
      "Is there a way to view my assignments by their due dates?",
      "How many students have already completed the course?"]



  const textLines = [
    "Analysing the input...",
    "Fetching the database Schema...",
    "Generating Query...",
    "Fetching data from Database...",
    "Getting a response...",
  ];

  return (
    <ChatDrawer
      // customSuggestionComponent={<ChatbotLandingPage userName={name} />}
      isOpen={isOpen}
      isWorkWebEnableForAll={true}
      isWebAllowed={isWebAllowed}
      queryMetaData={queryMetaData}
      config={chatbotConfig} // Pass centralized config
      setUserObj={user}
      setToken={token ?? ""} // mandatory
      onClose={() => {
        dispatch(setDrawerState(false));
        dispatch(setQueryMetaData(null));
        // Clear agentData and initialProjectId when drawer closes
        dispatch(setAgentData(undefined));
        dispatch(setInitialProjectId(undefined));
        // Clear dropdownSelectedProjectId from Zustand store when drawer closes
        useChatSessionStore.getState().setDropdownSelectedProjectId(null);
      }}
      userAvatar={userAvatarPath}
      aiAvatar={aiAvatarPath}
      AIAssistantTitleString="What would you like to know?"
      // AIAssistantname={brandingConfig?.appName || "General - AI Assistant"}
            AIAssistantname={brandingConfig?.chatbotname || brandingConfig?.chatbotname}

      suggestionPrompts={suggestionPrompt}
      thinkingText={textLines}
      isSearchFieldNeeded={true}
      // aufgangAnimationUrl={AufgangAnimation}
      aufgangAnimationAlt="General AI Assistant"
      thumbUpIcon={thumbUp}
      thumbDownIcon={blue_dislike}
      //    aufMinUrl={studentDashboard_AI_chatbot_image}
      //   openInFullIconUrl={open_in_full_icon}
      //   nonExpandIconUrl={non_expand}
      //   historyIconUrl={history_icon}
      //   chatCloseIconUrl={chat_close_icon}
      //   chatbotDownArrowUrl={chatbot_down_arrow}
      //   chatbotUpArrowUrl={chatbot_up_arrow}
      //   replyChatIconUrl={reply_chat}
      //   chatMicOffIconUrl={chat_mic_off_icon}
      //   miconUrl={micon}
      //   chatbotMicIconUrl={chatbot_mic_icon}
      logoVideoUrl={studentDashboard_AI_chatbot_image}
      // chatSendIconUrl={chat_send_icon}
      // chatSendIconWhiteUrl={chat_send_icon_white}
      // chatRefreshIconUrl={chat_refresh_icon}
      //  logoVideoUrl={logoVideo}
      sendButtonColor="#0068FF"
      sendButtonHoverColor="#2396D8"
      workWebToggleTextColor="#0068FF"
      aiTextIconUrl={srds_ai}
      //the  ai chat profile picture
      defaultProjectPlaceholder={brandingConfig?.chatbotname || brandingConfig?.chatbotname}
      loadMoreMessagesText="Load more messages"
      loadingMoreMessagesText="Loading more messages..."
      historyModalConfig={{
        title: "History",
        //  backIconUrl: back_arrow,
        //  closeIconUrl: chat_close_icon,
        searchPlaceholder: "Search in courses",
        // noResultsText: "No results found.",
      }}
      projectSidebarConfig={{
        //   title: "Rob AI",
        //  logoAnimationUrl: AufgangAnimation,
        //logoOverlayUrl: auf_min,

        searchPlaceholder: "Search in courses",
        //noResultsText: "No results found.",
      }}

      isHistoryIconVisible={true && isWebAllowed}
      isExpandableButtonEnable={true && isWebAllowed}
      isProjectDropdownVisible={true}
      isProjectChangeIconVisible={true && isWebAllowed}
      workWebToggleInactiveTextColor="#7D8175"
      // Color customization props for FeedbackForm (using default Tailwind config values)
      feedbackBackgroundColor="#FFFFFF" // bg-white
      feedbackBorderColor="#ECECEB" // line
      feedbackTextColor="#7D8175" // count-gray
      feedbackButtonColor="#2396D8" // brand-blue
      feedbackButtonHoverColor="#2396D8" // brand-blue
      feedbackPlaceholderColor="#464C3B" // gray-300
      // Input placeholder customization
      workModePlaceholder="Hi! ask me anything"
      webModePlaceholder="Search the web…"
      listeningPlaceholder="Listening"
      aiThinkingPlaceholder="AI is thinking..."
      workLabel="School"
      agentData={agentData}
      initialProjectId={initialProjectId}

    />
  );
};

export default ChatDrawerWrapper;